import { render, staticRenderFns } from "./ComplieChildMenuWrappingLineTilte.vue?vue&type=template&id=72fa4dfc&scoped=true"
import script from "./ComplieChildMenuWrappingLineTilte.vue?vue&type=script&lang=js"
export * from "./ComplieChildMenuWrappingLineTilte.vue?vue&type=script&lang=js"
import style0 from "./ComplieChildMenuWrappingLineTilte.vue?vue&type=style&index=0&id=72fa4dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa4dfc",
  null
  
)

export default component.exports